import React from "react";
import { Product } from "../constants";
import Avatar from "../static/images/avata.svg";
// import '../styles-others.css'
import '../loader.css'
export default function Typing({ productId, agentName, isService, loader }) {
  return (
    <>
      {(productId === Product.Health || isService) && (!agentName || loader)?
        <li className="you"  >
            {isService && !agentName ?
            <img src={Avatar} class="grop_message tia-icon"></img>
            : null
          }
          <div class="grop_message">
            {/* <div class="message"> */}
            <div class="stage">
              <div class="dot-typing"></div>
              {/* </div> */}
            </div>
          </div>
          {/* {isService && !agentName ?
            <img src={Avatar} class="grop_message tia-icon"></img>
            : null
          } */}
        </li> : null}
    </>
  );
}
